"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var FileTypeXls = function FileTypeXls(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    fill: "#207245",
    fillRule: "evenodd",
    d: "M8 0C5.796875 0 4 1.796875 4 4v7H1c-.550781 0-1 .449219-1 1v6c0 .550781.449219 1 1 1h3v3c0 2.203125 1.796875 4 4 4h12c2.203125 0 4-1.796875 4-4V8c0-1.0625-.972656-2.070312-2.71875-3.78125-.242187-.238281-.503906-.503906-.75-.75-.246094-.246094-.511719-.476562-.75-.71875C18.070313 1.003906 17.0625 0 16 0H8zm0 2h7.28125c.722656.183594.71875 1.050781.71875 1.9375V7c0 .550781.449219 1 1 1h3c.996094 0 2 .003906 2 1v13c0 1.105469-.894531 2-2 2H8c-1.105469 0-2-.894531-2-2v-3h12c.550781 0 1-.449219 1-1v-6c0-.550781-.449219-1-1-1H6V4c0-1.105469.894531-2 2-2z"
  }), (0, _preact.h)("path", {
    fill: "#fff",
    d: "M4.87695 14.2734l1.06641-1.9609h1.34766l-1.65625 2.8203L7.33398 18H5.9707l-1.09375-1.9922L3.7832 18H2.41992l1.69922-2.8672-1.65625-2.8203h1.34765l1.06641 1.9609zm4.21875 2.7852h2.48828V18H7.92383v-5.6875h1.17187v4.7461zm6.10938-.5508c0-.2213-.0781-.3913-.23438-.5097-.15624-.1185-.4375-.2435-.84375-.375-.40624-.1315-.72786-.2611-.96484-.3887-.64583-.349-.96875-.8191-.96875-1.4102 0-.3073.0866-.5814.25977-.8223.17318-.241.42187-.429.74609-.5644.32422-.1354.68815-.2031 1.0918-.2031.40625 0 .76823.0735 1.08594.2207.31771.1471.56445.3548.74024.623.17578.2682.26367.5729.26367.914h-1.17188c0-.2604-.08203-.463-.24609-.6074-.16407-.1446-.39453-.2168-.69141-.2168-.28646 0-.5091.0605-.66797.1816-.15885.121-.23828.2805-.23828.4785 0 .1849.0931.3398.2793.4648.18619.125.46028.2422.82226.3516.66667.2005 1.15239.4492 1.45704.746.30469.2969.45703.6667.45703 1.1094 0 .4922-.18619.8783-.55859 1.1582-.3724.28-.87369.4199-1.50391.4199-.4375 0-.83594-.0801-1.19531-.2403-.35938-.16-.63346-.3794-.82227-.6582-.18879-.2786-.2832-.6015-.2832-.9687h1.17578c0 .6276.375.9414 1.125.9414.27864 0 .49609-.0566.65234-.1699.15625-.1133.23438-.2715.23438-.4746z"
  }));
};

var _default = FileTypeXls;
exports.default = _default;